module.exports = __webpack_public_path__ + "images/7d2eb35.jpg";